import React from 'react';
import { PayloadStates } from '@lore/utils';
import ChartLoader from '../../states/_charts/ChartLoader';
import DonutChart from '../../states/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import useQuestionsReal from './_hooks/useQuestionsReal';

export default function QuestionCreatorYear(props) {
  const { state, network, schoolStart, schoolEnd, subtitle } = props;

  const questions = useQuestionsReal(state, network, schoolStart, schoolEnd, undefined, {
    project: {}
  });

  const _creatorData = questions.data.filter(q => q.data._eager.project.creatorId === q.data.creatorId);
  const creatorQuestions = {
    state: questions.state,
    data: _creatorData,
    meta: {
      totalCount: _creatorData.length
    }
  };

  const _stewardData = questions.data.filter(q => q.data._eager.project.creatorId !== q.data.creatorId);
  const stewardQuestions = {
    state: questions.state,
    data: _stewardData,
    meta: {
      totalCount: _stewardData.length
    }
  };

  const requests = [
    {
      label: 'Invited by Educator',
      questions: creatorQuestions
    },
    {
      label: 'Invited by Steward',
      questions: stewardQuestions
    }
  ]

  const loading = _.reduce(requests, function(result, request) {
    return (
      result ||
      request.questions.state === PayloadStates.FETCHING
    );
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title="Breakdown of who invited the partner"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const series = requests.map(r => r.questions.meta.totalCount);
  const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title="Breakdown of who invited the partner"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.yellow['400']
      ]}
    />
  );
}
